import { useMemo } from 'react';
import { useAppStore } from '@indipia/shared';
import { usePhotoCommonStore } from '../store/photoCommonStore';

export function useTagCodeMaps() {
  const commonCodes = usePhotoCommonStore(s => s.commonCodes);
  const appCodes = useAppStore(s => s.codes);

  const spaceCodeByName = useMemo(() => Object.fromEntries(
    (commonCodes?.['A01_SPACE_TAG'] ?? []).map(c => [c.codeName, c.code])
  ), [commonCodes]);

  const workCodeByName = useMemo(() => Object.fromEntries(
    appCodes.filter(c => c.codeGroupCode === 'ZEU_WORK_TYPE').map(c => [c.codeName, c.codeValue])
  ), [appCodes]);

  return { spaceCodeByName, workCodeByName };
}
